import { createContext, useContext, ReactNode } from 'react';

interface AddPetModalContextValue {
  openAddPet: () => void;
}

const AddPetModalContext = createContext<AddPetModalContextValue | null>(null);

export function AddPetModalProvider({
  children,
  openAddPet,
}: {
  children: ReactNode;
  openAddPet: () => void;
}) {
  return (
    <AddPetModalContext.Provider value={{ openAddPet }}>
      {children}
    </AddPetModalContext.Provider>
  );
}

export function useAddPetModal(): AddPetModalContextValue | null {
  return useContext(AddPetModalContext);
}
